import { Star } from 'lucide-react';

export function StarRating({ value = 0, size = 14, onChange }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!onChange}
          onClick={() => onChange && onChange(n)}
          className={onChange ? 'cursor-pointer' : 'cursor-default'}
          data-testid={onChange ? `star-${n}` : undefined}
        >
          <Star
            size={size}
            className={n <= Math.round(value) ? 'fill-gold text-gold' : 'text-muted-foreground'}
          />
        </button>
      ))}
    </div>
  );
}
